import React from 'react';
import { Link } from 'react-router-dom';
import { getConvertedPrice } from '../../utils/Utilities';

const ProductCard = ({ product, currency }) => {
    const productImage = product.itemObj?.image || product.image;
    const price = product.min_price || product.price;

    return (
        <div className="product-card-fine position-relative mb-4">
            <Link to={`/productdetail?product_id=${product.item_id || product.id}`} className="text-decoration-none">
                <div className="card border-0 bg-transparent">
                    {/* Image Canvas */}
                    <div className="product-image-canvas overflow-hidden rounded-4 position-relative">
                        <img
                            src={productImage}
                            alt={product.item_name || product.name || "Product"}
                            className="img-fluid w-100 transition-transform duration-500 hover-scale"
                            loading="lazy"
                            width="300"
                            height="300"
                        />

                        {/* Badges */}
                        {product.is_sale === 1 && (
                            <div className="position-absolute top-0 start-0 m-3 px-3 py-1 badge-sale-green text-white font-heading fs-xs rounded-pill ls-1">
                                SALE
                            </div>
                        )}

                        {product.is_new === 1 && product.is_sale !== 1 && (
                            <div className="position-absolute top-0 end-0 m-3 px-3 py-1 badge-new-blink text-white font-heading fs-xs rounded-pill ls-1">
                                NEW
                            </div>
                        )}

                        {/* Quick View Button */}
                        <button className="btn-quick-view position-absolute bottom-0 end-0 m-3 d-flex align-items-center justify-content-center shadow-lg" aria-label={`View ${product.item_name || product.name || 'product'}`}>
                            View
                        </button>
                    </div>

                    {/* Content */}
                    <div className="card-body px-0 pt-3">
                        <h6 className="font-heading text-dark text-uppercase ls-1 mb-1 text-truncate">
                            {product.item_name || product.name}
                        </h6>
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-primary fw-bold fs-5">
                                {currency?.currency?.symbol || '$'} {getConvertedPrice(price)}
                            </span>
                            {product.old_price && (
                                <span className="text-muted text-decoration-line-through fs-xs">
                                    {currency?.currency?.symbol} {getConvertedPrice(product.old_price)}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default ProductCard;
